"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultInsightMenuItems = void 0;
var tslib_1 = require("tslib");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
/**
 * @internal
 */
function getDefaultInsightMenuItems(intl, config) {
    var exportCSVDisabled = config.exportCSVDisabled, exportXLSXDisabled = config.exportXLSXDisabled, scheduleExportDisabled = config.scheduleExportDisabled, onExportCSV = config.onExportCSV, onExportXLSX = config.onExportXLSX, onScheduleExport = config.onScheduleExport, isScheduleExportVisible = config.isScheduleExportVisible, isDataError = config.isDataError;
    var tooltip = isDataError
        ? intl.formatMessage({ id: "options.menu.unsupported.error" })
        : intl.formatMessage({ id: "options.menu.unsupported.loading" });
    return compact_1.default([
        {
            type: "button",
            itemId: "ExportXLSXBubble",
            itemName: intl.formatMessage({ id: "widget.options.menu.exportToXLSX" }),
            onClick: onExportXLSX,
            disabled: exportXLSXDisabled,
            tooltip: tooltip,
            icon: "gd-icon-download",
            className: "s-options-menu-export-xlsx",
        },
        {
            type: "button",
            itemId: "ExportCSVBubble",
            itemName: intl.formatMessage({ id: "widget.options.menu.exportToCSV" }),
            onClick: onExportCSV,
            disabled: exportCSVDisabled,
            tooltip: tooltip,
            icon: "gd-icon-download",
            className: "s-options-menu-export-csv",
        },
        isScheduleExportVisible && {
            type: "button",
            itemId: "ScheduleExport",
            itemName: intl.formatMessage({ id: "widget.options.menu.scheduleExport" }),
            onClick: onScheduleExport,
            disabled: scheduleExportDisabled,
            tooltip: tooltip,
            icon: "gd-icon-clock",
            className: "s-options-menu-schedule-export",
        },
    ]);
}
exports.getDefaultInsightMenuItems = getDefaultInsightMenuItems;
//# sourceMappingURL=getDefaultInsightMenuItems.js.map